import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const OFStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.rtnFakturalayout,
  rutinInfos.rtnOrdermottagningsvag,
];

export default OFStyrvardeMeny;
